import { memo } from "react";
import { DialogContent as MuiDialogContent } from "@mui/material";
import { styled } from "@mui/material/styles";

import LoginForm from "components/auth/LoginForm";
import ClosableDialog from "components/shared/ClosableDialog";
import useDialog from "hooks/useDialog";

const LoginDialog: React.FC = () => {
  const { openLoginDialog, setOpenLoginDialog } = useDialog();

  return (
    <ClosableDialog
      open={openLoginDialog}
      onClose={() => setOpenLoginDialog(false)}
    >
      <DialogContent>
        <LoginForm />
      </DialogContent>
    </ClosableDialog>
  );
};

export default memo(LoginDialog);

const DialogContent = styled(MuiDialogContent)({
  padding: "0 32px !important",
});
